import moment from "moment";

import ClubCrest from "@/components/ClubCrest";
import PlayerAvatar from "@/components/PlayerAvatar";
import ScoreRing from "@/components/ScoreRing";
import {STATURE_LABELS, statureFromHeight} from "@/utils/scoutingData";
import {getPipelineStage} from "@/utils/scoutingPipeline";
import {getVerdict} from "@/utils/scoutingReports";

import "./index.scss";

// Card di un giocatore esterno: identità, squadra, stadio in pipeline e ultime relazioni.
export default function ScoutPlayerTile({
	player,
	pipelineEntry,
	reports,
	large = false,
	onClick,
	action,
}) {
	const role = player?.goalkeeper
		? "Portiere"
		: player?.secondaryRole || player?.primaryRole;
	const birth = player?.dateOfBirth ? moment(player.dateOfBirth) : null;
	const club = player?.roster?.club;
	const stage = getPipelineStage(pipelineEntry?.status);
	const verdict = getVerdict(reports?.lastVerdict);
	const details = large
		? [
				player?.nationality,
				player?.favoriteFoot && "Piede " + player.favoriteFoot,
				player?.height &&
					[
						player.height + " cm",
						STATURE_LABELS[statureFromHeight(player.height)],
					]
						.filter(Boolean)
						.join(" "),
			].filter(Boolean)
		: [];
	const Tag = onClick ? "button" : "div";

	return (
		<Tag
			type={onClick ? "button" : undefined}
			className={
				"scout-tile" +
				(large ? " scout-tile--large" : "") +
				(onClick ? " scout-tile--clickable" : "")
			}
			onClick={onClick}
		>
			<PlayerAvatar
				firstName={player?.firstName}
				lastName={player?.lastName}
				imageUrl={player?.imageUrl}
				size={large ? "large" : "medium"}
			/>
			<span className="scout-tile__body">
				<span className="scout-tile__name">
					{[player?.lastName, player?.firstName].filter(Boolean).join(" ")}
				</span>
				<span className="scout-tile__meta">
					{[
						role,
						birth &&
							birth.year() + " · " + moment().diff(birth, "years") + " anni",
					]
						.filter(Boolean)
						.join(" · ")}
				</span>
				{club?.name && (
					<span className="scout-tile__club">
						<ClubCrest
							name={club.name}
							logoUrl={club.imageUrl}
							colors={club.colors}
							size={16}
						/>
						{club.name}
					</span>
				)}
				{!!details.length && (
					<span className="scout-tile__meta">{details.join(" · ")}</span>
				)}
				{(stage || verdict) && (
					<span className="scout-tile__tags">
						{stage && (
							<span
								className="scout-tile__tag"
								style={{color: stage.color, background: stage.bg}}
							>
								{stage.label}
							</span>
						)}
						{verdict && (
							<span
								className="scout-tile__tag"
								style={{color: verdict.color, background: verdict.bg}}
							>
								{verdict.label}
								{reports.reportsCount > 1 &&
									" · " + reports.reportsCount + " relazioni"}
							</span>
						)}
					</span>
				)}
			</span>
			{reports?.average != null && (
				<ScoreRing
					value={reports.average}
					max={5}
					size="small"
					label="Relazioni"
				/>
			)}
			{action && <span className="scout-tile__action">{action}</span>}
		</Tag>
	);
}
